import React, { useMemo } from 'react';

import { Table } from 'components/WrappedComponents';
import {
  ColumnProps,
  FetchDataFunction,
} from 'components/WrappedComponents/Table/types';
import { usePaginationContext } from 'hooks/PaginationStoreContext';
import { useSortContext } from 'hooks/SortStoreContext';

import {
  SupervisionUserEventsFilter,
  SupervisionUserEventsFilterFormValues,
} from '../SupervisionHeader/types';
import { useSupervisionUserEventsFilterContext } from '../useSupervisionUserEventsFilterContext';

import { SortOptions, useSearchUserEventsDto } from './useSearchUserEventsDto';
import { buildColumns, buildHeader, UtilisateursResponseDto } from './utils';

import './styles.less';

const SupervisionTable = () => {
  const [pagination, setPagination] = usePaginationContext(
    'paginationSupervisionComptes',
  );
  const [sort, setSort] = useSortContext();
  const [filter, setFilter] = useSupervisionUserEventsFilterContext();

  const columns: ColumnProps<UtilisateursResponseDto, SortOptions>[] = useMemo(
    () => buildColumns(),
    [],
  );

  const searchUserEvents = useSearchUserEventsDto();

  const fetchData: FetchDataFunction<
    UtilisateursResponseDto,
    SupervisionUserEventsFilterFormValues,
    SortOptions
  > = useMemo(
    () =>
      (
        pagination,
        sorters,
        {
          dateRangeRealisation,
          operations,
          profils,
        }: SupervisionUserEventsFilter,
      ) =>
        searchUserEvents(pagination, sorters, {
          dateRangeRealisation: dateRangeRealisation,
          operations: operations || [],
          profils: profils || [],
        }),
    [searchUserEvents],
  );

  return (
    <div className="table-container">
      <Table
        header={buildHeader}
        columns={columns}
        fetchData={fetchData}
        buildItemKey={(item): string => item.id}
        pageSizeOptions={[10, 20, 50]}
        pagination={pagination}
        setPagination={setPagination}
        filter={filter}
        setFilter={setFilter}
        sort={sort}
        setSort={setSort}
      />
    </div>
  );
};

export default SupervisionTable;
